var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.086 138.695h72.812c-.816 8.024-1.605 15.239-4.035 23.262H176.38l-21.043-73.75h-28.324l-21.84 67.348L82.52 88.207H53.406l-19.41 73.75-3.246 16.047h20.23l19.407-73.75 24.265 66.539c1.606 4.809 5.668 7.21 10.52 7.21 4.855 0 9.707-3.214 11.316-8.023l22.653-66.539 17.8 64.137c1.61 6.402 7.282 10.426 13.77 10.426h78.484c-19.41 45.71-65.535 78.562-119.73 78.562C58.258 256.566 0 198.832 0 128.296 0 57.759 58.258 0 129.465 0c57.437 0 105.988 36.875 122.972 87.395h-80.91l4.852 16.046h80.914c1.605 7.215 2.426 13.645 2.426 20.856h-76.852l3.246 14.426zm0 0",
    fill: "#0068d1"
  })));
}
export default SvgLogoMyle;